// extracted by mini-css-extract-plugin
module.exports =  {"loader":"loader__QrepW","message":"message__jP9Tx"};